import { getPortDetails } from '../../../api/getEntrySummaryData'
import store from '../../../store'
import { Popup, Icon, Button } from 'semantic-ui-react'
import React from 'react'

export const displayMasterItem = (id, masterList) => {
  let result = id
  let item
  if (masterList) {
    item = masterList.find(obj => obj.value == id)
    if (item) {
      if (item.value && item.text && item.description) {
        result = item.text;
      } else if (item.value && item.text) {
        result = item.text + ' - ' + result;
      }
    }
  }
  if (typeof result == "string") {
    return result.replace('_BLANK_','').replace('-999','').replace(/_/g, " ")
  }
  return result;
}

export const simaSubjectCodeDropdown = [
  {id: "0", text: "Please Choose", value:"_BLANK_"},
  {id:"1" , text: "Non-Subject", value: "N"},
  {id:"2" , text: "Subject", value: "S"},
  {id:"3" , text: "Undertaking Applicable", value: "U"},
]

export const displayTariffTreatement = (id, masterList) => {
  let result = id
  let item
  if (masterList) {
    item = masterList.find(obj => obj.value == id)
    if (item) {
      if (item.value && item.text && item.description) {
        result = item.text;
      } else if (item.value && item.text) {
        result = item.text;
      }
    }
  }
  if (typeof result == "string") {
    return result.replace('_BLANK_','').replace('-999','').replace(/_/g, " ")
  }
  return result;
}
export const displayMasterItem2 = (id, masterList) => {
  let result = id
  let item
  if (masterList) {
    item = masterList.find(obj => obj.value == id)
    if (item) {
      if (item.value && item.text && item.description) {
        result = item.text;
      } else if (item.value && item.text) {
        result = result + ' - ' + item.text;
      }
    }
  }
  if (typeof result == "string") {
        return result.replace('_BLANK_','').replace('-999','').replace(/_/g, " ")
  }
  return result;
}

export const displayDropDown = (id, masterList) => {
  let result = id
  let item
  if (masterList) {
    item = masterList.find(obj => obj.value === id)
    if (item && (item.text || item.description)) {
      result = (item.text || item.description)
    }
  }
  if (typeof result == "string") {
    return result.replace('_BLANK_','').replace('-999','').replace(/_/g, " ")
  }
  return result
}


export const buildPortValue = (portCode, updateAction) => {
  if (!portCode) {
    return {
      id: '',
      title: '',
      masterSet: false
    }
  } else {
    getPortDetails(portCode)
      .then(response => {
        if (response.data.eventMessage.list.length > 0) {
          store.dispatch(
            updateAction({
              id: response.data.eventMessage.list[0].portCode || '',
              title:
                (response.data.eventMessage.list[0].portName || '') +
                ', ' +
                (response.data.eventMessage.list[0].portProvince || ''),
              masterSet: Boolean(
                response.data.eventMessage.list[0].portCode
              )
            })
          )
        }
      })
      .catch(err => {
        console.error(
          'Could not find port associated with Port Code:',
          portCode,
          err
        )
      })
  }
}

// Returns an icon as specified with text displaying on hover
export const getPopUpIcon = (
  icon,
  popupText,
  className,
  merchandiseId,
  lineItemIndex
) => {
  return (
    <Popup
      trigger={<Icon className={className} name={icon} color={'blue'} />}
      hideOnScroll
      on='click'
      content={
        <Button
          className='footnote-button'
          onClick={
            () => { }
            // merchandiseId &&
            // createMerchandiseDutyItem(
            //   merchandiseId,
            //   lineItemIndex,
            //   null,
            //   popupText.replace(/[^0-9.]/g, '')
            // )
          }
        >
          {popupText}
          {/* {' '}
          <Icon name='add circle' /> */}
        </Button>
      }
    />
  )
}

export const getDocCodeNameForPGA = (docCodeName, pga) => {
  const codeMap = {
    "OMC_OMC": "OMC01",
    "NMF_370": "NMF01",
    "EPA_PS1": "EPA04",
    "EPA_PS3": "EPA04",
  }
  if(!docCodeName || docCodeName === "N/A"){
    return codeMap[pga]
  }
  return docCodeName
}
